import axios from 'axios'
const service = axios.create({
	baseURL: process.env.BASE_API, // api 的 base_url
	timeout: 15000 // request timeout
})

// request interceptor
service.interceptors.request.use(
	config => {

		return config
	},
	error => {
		console.log(error) // for debug
		Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	response => {

		return response
	},
	error => {
		console.log('err' + error) // for debug

		return Promise.reject(error)
	}
)

export default service



// WEBPACK FOOTER //
// ./src/api/index.js